module.exports = __webpack_public_path__ + "static/media/vf_wtop_core.f40f8101.svg";